{
  "create": {
    "button_text": "Create Note",
    "button_text_compact": "+ Note",
    "aria_label": "Create note"
  },
  "form": {
    "header": "Note",
    "placeholder": "Leave a note here",
    "validation_required": "Please enter a note",
    "contact_label": "Contact"
  },
  "access": {
    "manage_access": "Manage Access",
    "firm_wide": "Firm-Wide",
    "private": "Private"
  },
  "update": {
    "created_by": "Created by {{name}}",
    "last_updated_by": "Last Updated by {{name}}"
  },
  "display": {
    "private_label": "Private",
    "no_date_found": "No date found",
    "edit_aria_label": "edit note",
    "archive_aria_label": "archive note"
  },
  "archive": {
    "confirm_title": "Are you sure you want to archive this note?"
  }
}
